import { useEffect } from 'react';
import { useApiContext } from 'react-easyrocket';
import { Navigate, useSearchParams } from 'react-router';
import { BONUS_ID, PROMO_CODE } from 'src/constants/searchParams';
import { useModalContext } from 'src/hooks/useModalContext';
import { useAuthFlow } from 'src/modules/authFlow/hooks/useAuthFlow';
import { useRoute } from 'src/router/hooks';

export const DepositLink = () => {
  const { isAuthenticated } = useApiContext();
  const { openModal } = useModalContext();
  const isModalContextReady = typeof openModal === 'function';
  const isApiContextReady = typeof isAuthenticated === 'boolean';
  const [searchParams] = useSearchParams();
  const { startRegistration } = useAuthFlow();
  const { ROUTE } = useRoute();
  const promocode = searchParams.get(PROMO_CODE);
  const bonusId = searchParams.get(BONUS_ID);

  useEffect(() => {
    if (isModalContextReady && isApiContextReady) {
      if (isAuthenticated) {
        openModal('DEPOSIT', { props: { bonusId, promocode }, replace: true });
      } else {
        startRegistration({
          onSuccess: () => {
            openModal('DEPOSIT', { props: { bonusId, promocode }, replace: true });
          },
          defaultFlow: false
        });
      }
    }
  }, [isApiContextReady, isAuthenticated, isModalContextReady]);

  return <Navigate to={ROUTE.MAIN.get()} replace={true} />;
};
